import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import GeneralServices from '../../../app/service/generalServices'
import ConstantsUtil from '../../../context/constantsUtil'
import FichaDeEstoqueService from '../../../app/service/relatorios/fichaDeEstoqueService'
import { classNames } from 'primereact/utils'
import { Button } from 'primereact/button'
import DetalhamentoFluxoCaixaPrevistoDialog from '../../relatorios/fluxoCaixaPrevisto/detalhamentoFluxoCaixaPrevistoDialog'
import AuthService from '../../../app/service/authService'
import FluxoCaixaPrevistoService from '../../../app/service/relatorios/fluxoCaixaPrevistoService'
import HandleErrorService from '../../../app/service/handleErrorService'

const exportExcelEntradaLabel = "Entrada"
const exportExcelSaidaLabel = "Saída"
const exportExcelSaldoLabel = "Saldo"
const dataPagamentoLabel = 'Data de Pagamento'
const dataEmissaoLabel = 'Data de Emissão'
const dataLancamentoLabel = 'Data de Lançamento'
const dataValidacaoLabel = 'Data de Validação'
const dataCompetenciaLabel = 'Data de Competência'
class FluxoCaixaPrevistoTable extends React.Component {

    state = {
        visibleConfirmDeleteDialog: false,
        fichaDeEstoqueToDelete: '',

        loading: false,

        displayDetalhamentoDialog: false,
        elementToView: '',
    }

    constructor(){
        super();
        this.fichaDeEstoqueService = new FichaDeEstoqueService();
        this.fluxoCaixaPrevistoService = new FluxoCaixaPrevistoService();

    }

    getList(){
        const retorno = this.props.fluxoCaixaPrevisto && this.props.fluxoCaixaPrevisto.fluxoCaixaPrevistoList ? this.props.fluxoCaixaPrevisto.fluxoCaixaPrevistoList : []
        return retorno
    }

    viewDetalhamento = (rowData, from) => {
        this.setState({displayDetalhamentoDialog: true})
        rowData.tipoDetalhamento = from
        this.setState({elementToView: rowData})
    }
    
    hideDialog = async () => {
        await this.setState({displayDetalhamentoDialog: false})
        await  this.setState({elementToView: ''})
    }

    getDialogLabel = () => {
        if(!this.state.elementToView){
            return ""
        }
        switch (this.state.elementToView.tipoDetalhamento) {

            case ConstantsUtil.saldoLabel:
              return "Saldos Bancários"

            case ConstantsUtil.entradaLabel:
                return "Lançamentos de Contas a Receber"

            case ConstantsUtil.saidaLabel:
                return "Lançamentos de Provisão de Pagamento"

        }

    }

    rowClass(rowData) {
        return {
            [ConstantsUtil.totaisTableLabel]: rowData.tipo === ConstantsUtil.totaisTableUpperCaseLabel
        }
    }

    getListToExport = () => {
        var finalList = []
        this.getList().forEach(item => {
            finalList.push({
                [dataLancamentoLabel]: item.dataString ? item.dataString : item.tipo,
                [exportExcelEntradaLabel]: item.entrada,
                [exportExcelSaidaLabel]: item.saida,
                [exportExcelSaldoLabel]: item.saldo
            })
        })
        return finalList
    }

    getDetalhamentoListToExport = (lancamentosList) => {
        // console.log("getDetalhamentoListToExport lancamentosList: ", lancamentosList)
        var finalList = lancamentosList.map(lancamento => {
            return {
                [dataPagamentoLabel]: lancamento.dataPagamento,
                [dataEmissaoLabel]: lancamento.dataEmissao,
                [dataLancamentoLabel]: lancamento.dataLancamento,
                [dataValidacaoLabel]: lancamento.dataValidacao,
                [dataCompetenciaLabel]: lancamento.dataCompetencia,
                [exportExcelSaidaLabel]: lancamento.valor,
                ['N° Documento']: lancamento.numeroDocumento,
                ['Descrição']: lancamento.nome,
                ['Grupo De Pagamento']: lancamento.grupoDePagamento,
                ['Fornecedor']: lancamento.fornecedor ? lancamento.fornecedor.nome : '',
                ['CNPJ']: lancamento.fornecedor ? lancamento.fornecedor.cnpj : '',
                ['Status']: lancamento.statusPagamento,
                ['Forma de Pagamento']: lancamento.formaDePagamento ? lancamento.formaDePagamento.descricao : '',
                ['Origem']: lancamento.origem
            }
        })

        return finalList
    }

    viewDadosPagamento = (parcelaProvisao) => {
        this.setState({
            parcelaToViewDadosPagamento: parcelaProvisao,
            displayDadosPagamentoDialog: true
        })
    }

    hideDadosPagamentoDialog = () => {
        this.setState({
            parcelaToViewDadosPagamento: null,
            displayDadosPagamentoDialog: false
        })
    }

    getDetalhamentoPagamentos = (detalhamentoList = [], index = 0) => {
        
        // console.log("")

        // console.log("index: ", index)
        // console.log("detalhamentoList: ", detalhamentoList)

        let list = this.getList()
        
        if( (index >= list.length) || (list[index].tipo === ConstantsUtil.totaisTableUpperCaseLabel) ){
            // console.log("finish ", index)
            this.exportExcel(detalhamentoList)
            return;
        }

        let lancamento = list[index]
        
        if(!lancamento.saida){
            this.getDetalhamentoPagamentos(detalhamentoList, index+1)
            return;
        }

        lancamento.tipoDetalhamento = ConstantsUtil.saidaLabel

        // console.log("chamou!")

        this.fluxoCaixaPrevistoService.getDetalhamento(lancamento)
        .then(response => {
            // console.log("response: ", index, response.data)
            detalhamentoList.push({
                data: lancamento.dataString,
                lancamentos: response.data
            })
            this.getDetalhamentoPagamentos(detalhamentoList, index+1)
        })
        .catch(error => {
            // console.log("error: ", error)
            HandleErrorService.handleError(error)
        })
    }

    exportExcel = (detalhamentoList) => {
        // console.log("exportExcel detalhamentoList: ", detalhamentoList)

        // console.log("detalhamentoList: ", detalhamentoList)
        let detalhamentoDiasUnificadosList = []
        for(let detalhamento of detalhamentoList){

            detalhamento.lancamentos.forEach(lancamento => lancamento["dataPagamento"] = detalhamento.data)
            detalhamentoDiasUnificadosList.push(...detalhamento.lancamentos)

            
        }
        
        // console.log("detalhamentoDiasUnificadosList: ", detalhamentoDiasUnificadosList)

        let headersMoeda = [exportExcelEntradaLabel, exportExcelSaidaLabel, exportExcelSaldoLabel]
        var workbook = GeneralServices.generateWorkbook(this.getListToExport(), "Fluxo de Caixa Previsto", headersMoeda)

        // let sheetName = `Pagamentos - ${detalhamento.data}`
        let sheetName = `Pagamentos Detalhados`
        let detalhamentoWorkbook = GeneralServices.generateWorkbook(
            this.getDetalhamentoListToExport(detalhamentoDiasUnificadosList),
            sheetName,
            headersMoeda
        )

        Object.assign(workbook.Sheets, detalhamentoWorkbook.Sheets)
        workbook.SheetNames.push(sheetName)
        
        // console.log("workbook: ", workbook)

        let filename = `Fluxo de Caixa Previsto_${AuthService.getEmpresa()}_de_${this.props.initialDate}_a_${this.props.finalDate}`
        GeneralServices.saveAsExcelFile(workbook, filename)

        AuthService.stopBlockUi()
    }

    callExportExcel = () => {
        AuthService.startBlockUi()
        this.getDetalhamentoPagamentos()
    }

    render(){

        const renderViewLancamentosLink = (rowData, valor, condToColor, condToLink, from) => {

            const condNonZero = valor > 0 || valor < 0

            const isTotais = rowData.tipo === ConstantsUtil.totaisTableUpperCaseLabel
            condToLink = condToLink && !isTotais
            
            const classes = classNames({
                'superavitValue': condToColor && valor >= 0,
                'deficitValue': condToColor && valor < 0,
                'linkValue': condToLink && condNonZero
            });
    
            if(condToLink && condNonZero){
                return(
                    <a 
                        className={classes}
                        onClick={() => this.viewDetalhamento(rowData, from)}
                    >
                        {GeneralServices.showFormattedIfNotNull(valor, true)}
                    </a>
                )
            }
            else{
                return(
                    <div className={classes}>
                        {condToLink ? GeneralServices.showFormattedIfNotNull(valor, true) : GeneralServices.showFormattedIfNonZero(valor, true)}
                    </div>
                )
            }
        }
        
        return (
            <>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    label="Exportar"
                    icon="pi pi-file-excel"
                    className="p-button-success"
                    onClick={this.callExportExcel}
                />
            </div>

            <DataTable 
                ref={this.dt}
                value={this.getList()}
                className="p-datatable-sm small-font"
                rowHover
                rowClassName={this.rowClass}
                showGridlines
                scrollable
                scrollHeight="500px"
                emptyMessage={ConstantsUtil.nenhumLancamentoEncontradoMessage}
                loading={this.props.loading || this.state.loading}
                dataKey="id"
                paginator rows={ConstantsUtil.initialTableQuantityOption}
                paginatorTemplate={GeneralServices.tablePaginatorTemplate(ConstantsUtil.initialTableQuantityOption, this.getList().length)}
                currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} lançamentos"
            >

            <Column
                header="Data"
                field="data"
                body={rowData => rowData.tipo === ConstantsUtil.totaisTableUpperCaseLabel ? ConstantsUtil.totaisTableUpperCaseLabel : rowData.dataString}
                sortable style ={ {width: '80px'} }
                // filter filterElement={codeFilterElement}
             />

            <Column
                header="Entrada"
                field="entrada" 
                body = {rowData => {
                    return (
                        <div className='right-align'>
                            {renderViewLancamentosLink(rowData, rowData.entrada, false, rowData.tipo !== ConstantsUtil.saldoLabel, ConstantsUtil.entradaLabel)}
                        </div>
                    )
                }}
                sortable style ={ {width: '80px'} }
            />

            <Column
                header="Saída" 
                field="saida" 
                body = {rowData =>  {
                    return (
                        <div className='right-align'>
                            {renderViewLancamentosLink(rowData, rowData.saida, false, rowData.tipo !== ConstantsUtil.saldoLabel, ConstantsUtil.saidaLabel)                            }
                        </div>
                    )
                }}
                sortable style ={ {width: '80px'} }
            />

            <Column
                header="Saldo" 
                field="saldo" 
                sortable style ={ {width: '80px'} }
                body = {rowData => {
                    return (
                        <div className='right-align'>
                            {renderViewLancamentosLink(rowData, rowData.saldo, true, rowData.tipo === ConstantsUtil.saldoLabel, ConstantsUtil.saldoLabel)}
                        </div>
                    )                    
                }}
            />

            {/* <Column body={actionBody} style ={ {width: '80px'} }
            /> */}

        </DataTable>

            <DetalhamentoFluxoCaixaPrevistoDialog
                visible={this.state.displayDetalhamentoDialog}
                header={this.getDialogLabel()}
                fluxoCaixaPrevisto={this.props.fluxoCaixaPrevisto}
                element={this.state.elementToView}
                loadingTable={false}
                hideDialog={this.hideDialog}
            />            

        </>
        )
    }

}


export default FluxoCaixaPrevistoTable